// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"600":"0ec22fdf","820":"547d5777"}[chunkId] + ".chunk.js";
};